<div class="card overview-card">
  <a
    [href]="item.name + '.xlsx'"
    (click)="$event.preventDefault(); downloadReport$.next(item.id)"
    *ngFor="let item of reports"
    >{{item.name}}</a
  >
</div>
